import DiggerLogo from './DiggerLogo';

interface SplashScreenProps {
  visible: boolean;
}

export default function SplashScreen({ visible }: SplashScreenProps) {
  return (
    <div
      role="status"
      aria-label="A carregar DIGGER CDI"
      aria-hidden={!visible}
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-brand-purple text-white transition-opacity duration-500 ${
        visible ? 'opacity-100' : 'pointer-events-none opacity-0'
      }`}
    >
      <DiggerLogo className="w-56 h-56" />
      <div className="mt-10 h-px w-16 bg-white/70" />
      <h1 className="mt-8 text-xl font-black tracking-wide text-brand-green">
        DIGGER CDI
      </h1>
      <p className="mt-2 max-w-xs text-center text-sm font-bold text-white/90">
        Laboratórios Inovação Social com Tecnologia
      </p>
    </div>
  );
}
